import { FormattedMessage, defineMessage } from 'react-intl';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { LanguageSwitcher } from '#src/components/user/LanguageSwitcher/index.tsx';

const message = defineMessage({
  defaultMessage: 'Language',
});

export const PreferredLanguage = () => {
  return (
    <SettingsSection title={message}>
      <Vertical>
        <BodyM>
          <FormattedMessage defaultMessage="Preferred language" />
        </BodyM>
        <LanguageSwitcher
          renderButton={({ content, ...props }) => (
            <Button {...props} size="small" color="tertiary">
              {content}
            </Button>
          )}
        />
      </Vertical>
    </SettingsSection>
  );
};
